<template>
    <div class="ds-schedule-select">
        <div class="ds-schedule-select-all">
            <checkbox :model-value="allSelected" layout="inline" @update:model-value="onSelectAll">Все сотрудники</checkbox>
            <span class="ds-schedule-select-count">{{ selectedCount ?? userSchedules.length }} из {{ userSchedules.length }}</span>
        </div>
        <div v-for="item in userSchedules" :key="item.id" class="ds-schedule-select-row">
            <checkbox v-model="item.checked" layout="inline" @change="onClick">
                <span class="ds-schedule-select-person">
                    <Avatar :first-name="item.user.first_name" :last-name="item.user.last_name" :url="item.user.avatar" width="32" height="32" font-size="xs" />
                    <span class="ds-schedule-select-text">
                        <span class="ds-schedule-select-name">{{ item.user.last_name }} {{ item.user.first_name }}</span>
                        <span v-if="item.position?.name" class="ds-schedule-select-position">{{ item.position.name }}</span>
                    </span>
                </span>
            </checkbox>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Schedule } from '@/types';
import { computed, ref } from 'vue';

interface Props {
    schedules: Schedule[]
    // Число выбранных из владельца выбора (MonthShiftsCopy); без него — все.
    selectedCount?: number
}

const props = defineProps<Props>()

const emit = defineEmits(['selected'])

const allSelected = ref(true)

const userSchedules = computed(() => props.schedules.map(item => {
    return { checked: true, id: item.id, user: item.user, shifts: item.shifts, position: item.position }
}))

const onClick = () => {
    const selectedSchedules = userSchedules.value.filter(item => item.checked)
    emit('selected', selectedSchedules)
    allSelected.value = selectedSchedules.length === userSchedules.value.length
}

const onSelectAll = (isSelected: boolean) => {
    allSelected.value = isSelected
    userSchedules.value.forEach(item => item.checked = isSelected)
    emit('selected', userSchedules.value.filter(item => item.checked))
}
</script>

<style scoped>
.ds-schedule-select-all {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
    border-bottom: 1px solid var(--color-bg-muted);
    font-family: var(--font-family-medium), sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: var(--color-text-main);
}

.ds-schedule-select-count {
    margin-left: auto;
    font-family: var(--font-family-base), sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: var(--color-text-muted);
}

.ds-schedule-select-row {
    padding: 6px 0;
}

.ds-schedule-select-person {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.ds-schedule-select-text {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.ds-schedule-select-name {
    font-family: var(--font-family-medium), sans-serif;
    font-size: 13px;
    font-weight: 500;
    color: var(--color-text-main);
}

.ds-schedule-select-position {
    font-size: 11px;
    color: var(--color-text-muted);
}
</style>
